/**
 * 관리자 위저드(`/sysadmin/wizard/backend`) STEP 5 '홈페이지 생성' 의 표시 모드.
 *
 * ## 배경 (2026-10-30)
 *
 * 홈페이지(= `hosting_info` 1행 + `{sub}.omoplay.com/view/site`)는 **오모플레이 제공 자사몰** 고객에게
 * 카카오 앱 심사·간편가입용 회원가입·약관·개인정보처리방침 URL 을 주기 위한 것이다.
 * 카페24 등 **외부 쇼핑몰로 신청한 고객은 자기 몰이 홈페이지**라 이 단계가 필요 없는데,
 * 종전 위저드는 연동 방식을 보지 않고 모든 채널에 홈페이지 생성을 강제했다.
 *
 * 판정 입력은 서버 `GET /sysadmin/wizard/channel/info` 의 `isExternalMall`(= `account_channel.hosting_name`)
 * 하나다. 신청서(`pendingChannel`)로 따로 유추하지 않는다 — 두 곳을 보면 어긋난다.
 *
 * 경위: `_ai-runs/2026-10-30_001_admin_wizard_cafe24_homepage_and_shipping/001_analysis.md`
 */

/** 종전과 같다. 홈페이지를 만들어야 다음으로 간다(오모플레이 자사몰 고객·연동 방식 미기록). */
export const HOMEPAGE_MODE_REQUIRED = 'REQUIRED'
/** 외부 몰 채널. 안내 카드 + '홈페이지 생성 없이 다음으로'. 작업자가 원하면 접힌 폼을 펴서 만들 수 있다. */
export const HOMEPAGE_MODE_OPTIONAL = 'OPTIONAL'
/** 이미 홈페이지가 있다(재세팅). 생성 폼 대신 기존 URL 을 보여준다. */
export const HOMEPAGE_MODE_EXISTS = 'EXISTS'

/**
 * @param channelInfo   `getWizardChannelInfo` 응답 `data`. 조회 전·실패·채널 없음이면 null.
 * @param hasOmoplaySite 이미 `hosting_info` 행이 있는가(`GET /hosting/info` 결과 또는 `channelInfo.omoplaySiteId`).
 *
 * 🔑 **모르면 REQUIRED** 다. 조회가 실패했을 때 홈페이지 단계를 조용히 건너뛰면, 오모플레이 자사몰 고객이
 *    약관 URL 없이 카카오 심사로 가게 된다(종전 동작이 안전한 쪽이다).
 */
export const homepageStepMode = (channelInfo, hasOmoplaySite) => {
    if (hasOmoplaySite) return HOMEPAGE_MODE_EXISTS
    if (channelInfo?.isExternalMall === true) return HOMEPAGE_MODE_OPTIONAL
    return HOMEPAGE_MODE_REQUIRED
}

/**
 * 카카오 심사·간편가입에 넣을 오모플레이 사이트 URL 3종. 홈페이지가 없으면 **null** 이다 —
 * 서브도메인이 비어 있을 때 `https://.omoplay.com/...` 같은 깨진 주소가 복사 칸에 나오면 안 된다.
 */
export const omoplaySiteUrls = (subdomain) => {
    if (!subdomain) return null
    const base = `https://${subdomain}.omoplay.com/view/site`
    return {site: base, signup: `${base}?view=signup`, privacy: `${base}?view=privacy`, terms: `${base}?view=terms`}
}
